import { GameModeDataController } from '@colonist/shared-types';
import { UIMRoomCardView } from './UIMRoomCardView.ts';
import { ModeSettingEnum, TemporaryModeSettingEnum } from '@colonist/game-base-types';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { createDivIn, createSpanIn, createLinkIn } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { sendRoomBecomeAMemberAnalytic } from '../../../../shared/scripts/analytics/sendRoomBecomeAMemberAnalytic.ts';
import { openSubscriptionOverlayInsteadOfLinkInVariant } from '../../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
import { showGameModeInfoDialog } from '../../../../shared/scripts/ui_popup/showGameModeInfoDialog.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
export class UIMRoomModeController {
    update(roomState) {
        for (const card of this.cardList){
            const isSelected = roomState.gameSetting.modeSetting == card.modeData.modeSetting;
            card.element.setSelect(isSelected);
            if (isSelected) this.isSelectedModeAccessible = card.isModeAccessible;
        }
    }
    createMembershipCTA() {
        var _ClientUserState_userState;
        if (UIUtilsEjsVariables.shouldHideStoreOnMobile) return;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) return;
        const membershipCTAContainer = createDivIn(this.container, 'room_center_become_a_member mobile-room');
        createSpanIn(membershipCTAContainer, '', {
            key: 'strings:roomPage.getAccessToAllMapsAndExpansions'
        });
        const becomeAMemberButton = createLinkIn(membershipCTAContainer, '/store#membership', {
            key: 'strings:homePage.becomeAMember'
        }, 'btn_general btn_general_no_margin btn_general_orange btn-general-become-a-member', '', true);
        openSubscriptionOverlayInsteadOfLinkInVariant(becomeAMemberButton);
        // eslint-disable-next-line no-restricted-syntax
        becomeAMemberButton.addEventListener('click', ()=>sendRoomBecomeAMemberAnalytic());
    }
    static sortModesByOwnership(modes) {
        modes.sort((a, b)=>{
            var _ClientUserState_userState, _ClientUserState_userState1;
            var _ClientUserState_userState_items_hasAccessToPremiumMode;
            const aAccessible = (_ClientUserState_userState_items_hasAccessToPremiumMode = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasAccessToPremiumMode(a)) !== null && _ClientUserState_userState_items_hasAccessToPremiumMode !== void 0 ? _ClientUserState_userState_items_hasAccessToPremiumMode : false;
            var _ClientUserState_userState_items_hasAccessToPremiumMode1;
            const bAccessible = (_ClientUserState_userState_items_hasAccessToPremiumMode1 = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.items.hasAccessToPremiumMode(b)) !== null && _ClientUserState_userState_items_hasAccessToPremiumMode1 !== void 0 ? _ClientUserState_userState_items_hasAccessToPremiumMode1 : false;
            if (aAccessible === bAccessible) return 0;
            return aAccessible ? -1 : 1;
        });
    }
    createAllCards() {
        const allGameModeData = GameModeDataController.publicGameModeDataList;
        const sortedModes = [
            ...allGameModeData
        ];
        UIMRoomModeController.sortModesByOwnership(sortedModes);
        for (const gameModeData of sortedModes){
            var _ClientUserState_userState;
            if (gameModeData.temporaryModeSetting == TemporaryModeSettingEnum.ServerStressTest) continue;
            const isCardLocked = !((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasAccessToPremiumMode(gameModeData));
            if (isCardLocked && UIUtilsEjsVariables.shouldHideStoreOnMobile) continue;
            const gameModeName = UIMRoomModeController.getGameModeName(gameModeData);
            const clickAction = ()=>{
                socket.roomClient.setGameMode(gameModeData.modeSetting);
            };
            const displayInfoAction = ()=>showGameModeInfoDialog(gameModeData);
            const card = new UIMRoomCardView(this.container, gameModeName, gameModeData.icon, isCardLocked, false, clickAction, displayInfoAction);
            this.cardList.push({
                modeData: gameModeData,
                element: card,
                isModeAccessible: !isCardLocked
            });
        }
    }
    static getGameModeName(gameModeData) {
        switch(gameModeData.modeSetting){
            case ModeSettingEnum.Classic56P:
                return {
                    key: 'strings:colonistCommon.gameModes.classic56P.abbreviation'
                };
            case ModeSettingEnum.Classic78P:
                return {
                    key: 'strings:colonistCommon.gameModes.classic78P.abbreviation'
                };
            case ModeSettingEnum.Seafarers56P:
                return {
                    key: 'strings:colonistCommon.gameModes.seafarers56P.abbreviation'
                };
            case ModeSettingEnum.CitiesAndKnights56P:
                return {
                    key: 'strings:colonistCommon.gameModes.citiesAndKnights56P.abbreviation'
                };
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
                return {
                    key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.abbreviation'
                };
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
                return {
                    key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.abbreviation'
                };
            default:
                return gameModeData.name;
        }
    }
    constructor(container, roomState){
        this.cardList = [];
        this.isSelectedModeAccessible = true;
        this.container = container;
        this.createMembershipCTA();
        this.createAllCards();
        this.update(roomState);
    }
}
